/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BankResponse } from '../../models/bank-response';

export interface GetApiBankV1Id$Plain$Params {

/**
 * The unique identifier of the bank.
 */
  id: number;

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
}

export function getApiBankV1Id$Plain(http: HttpClient, rootUrl: string, params: GetApiBankV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<BankResponse>> {
  const rb = new RequestBuilder(rootUrl, getApiBankV1Id$Plain.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BankResponse>;
    })
  );
}

getApiBankV1Id$Plain.PATH = '/private/v1/banks/{id}';
